export class OidcStateParams {
  returnRoute: string;
}
